import { Copy, Flex, Heading, Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';

interface AddNewPeopleSuccessModalRowProps {
  icon: JSX.Element;
  heading: string;
  copy: string;
}

export function AddNewPeopleSuccessModalRow({
  icon,
  heading,
  copy,
}: AddNewPeopleSuccessModalRowProps): JSX.Element {
  return (
    <Flex>
      <Stack x="sm" minWidth="70px">
        <Flex
          alignItems="center"
          justifyContent="center"
          width="70px"
          height="70px"
          borderRadius="50%"
          backgroundColor="rgba(0, 122, 255, 0.08)"
        >
          <Copy variant="body" color="interactive">
            {icon}
          </Copy>
        </Flex>
      </Stack>
      <Flex flexDirection="column">
        <Heading variant="h5">{heading}</Heading>
        <Copy variant="body" color="primary">
          {copy}
        </Copy>
      </Flex>
    </Flex>
  );
}
